<template>
    <span class="period-selector" @change="dateInputChanged">
        <v-select
            class="period-selector__period"
            v-model="activePreset"
            :options='calculatedPresets.map((preset) => {
                return {
                    text: preset[1].title,
                    value: preset[0]
                }
            })'
        ></v-select>

        <input type="date" v-model="datePicker.startDate" :min="startDateMinLimitation" :max="datePicker.endDate">
        <input type="date" v-model="datePicker.endDate" :min="endDateMinLimitation">
    </span>
</template>

<script>
import DateHelper from "../DateHelper";

export default {
    props: {
        excludedPresets: {
            type: Array,
            required: false,
            default: () => []
        },
        startDateMinLimitation: {
            type: String,
            required: false,
            default: "2000-01-01"
        },
        endDateMinLimitation: {
            type: String,
            required: false
        }
    },

    data: function () {
        return {
            presets: {
                today: {
                    getDates: () => DateHelper.getToday(),
                    title: 'Сегодня'
                },
                yesterday: {
                    getDates: () => DateHelper.getYesterday(),
                    title: 'Вчера'
                },
                dayBeforeYesterday: {
                    getDates: () => DateHelper.getDayBeforeYesterday(),
                    title: 'Позавчера'
                },
                lastThreeDays: {
                    getDates: () => DateHelper.getLastThreeDays(),
                    title: 'Последние 3 дня'
                },
                lastSevenDays: {
                    getDates: () => DateHelper.getLastSevenDays(),
                    title: 'Последние 7 дней'
                },
                lastNineDays: {
                    getDates: () => DateHelper.getLastNineDays(),
                    title: 'Последние 9 дней'
                },
                thisWeek: {
                    getDates: () => DateHelper.getCurrentWeek(),
                    title: 'Эта неделя'
                },
                lastWeek: {
                    getDates: () => DateHelper.getPreviousWeek(),
                    title: 'Прошлая неделя'
                },
                lastThirtyDays: {
                    getDates: () => DateHelper.getLastThirtyDays(),
                    title: 'Последние 30 дней'
                },
                thisMonth: {
                    getDates: () => DateHelper.getCurrentMonth(),
                    title: 'Этот месяц'
                },
                lastMonth: {
                    getDates: () => DateHelper.getPreviousMonth(),
                    title: 'Прошлый месяц'
                },
                lastThreeMonths: {
                    getDates: () => DateHelper.getLastThreeMonths(),
                    title: 'Последние 3 месяца'
                },
                lastThreeHundredSixtyFiveDays: {
                    getDates: () => DateHelper.getLastThreeHundredSixtyFiveDays(),
                    title: 'Последние 365 дней'
                },
                thisYear: {
                    getDates: () => DateHelper.getCurrentYear(),
                    title: 'Этот год'
                },
                lastYear: {
                    getDates: () => DateHelper.getPreviousYear(),
                    title: 'Прошлый год'
                }
            },

            datePicker: {
                activePreset: '',
                startDate: '',
                endDate: ''
            },
        };
    },

    computed: {
        calculatedPresets: function () {
            return Object.entries(this.presets).filter(([key, value]) => {
                return !this.excludedPresets.includes(key);
            });
        },

        activePreset: {
            get: function () {
                this.loadStorageDatepickerData();

                return this.datePicker.activePreset;
            },

            set: function (presetKey) {
                const preset = this.presets[presetKey];
                const presetDates = preset.getDates();

                this.datePicker.startDate = presetDates.startDate;
                this.datePicker.endDate = presetDates.endDate;
                this.datePicker.activePreset = presetKey;

                localStorage.setItem(this.storageKeyName, this.datePicker.activePreset);

                this.dateInputChanged();
            }
        },

        storageKeyName: function () {
            return location.pathname + '@vuedatepicker';
        },
    },

    methods: {
        dateInputChanged: function () {
            this.$emit('date-changed', this.datePicker.startDate, this.datePicker.endDate);
        },

        loadStorageDatepickerData: function () {
            const savedPreset = localStorage.getItem(this.storageKeyName);

            if (savedPreset !== null) {
                this.activePreset = savedPreset;
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.period-selector {
    display: flex;

    &__period {
        max-width: 140px;
    }

    > select {
        width: auto;
    }

    > input[type=date] {
        width: 140px;
        margin-left: 10px
    }

    &.large {
        > * {
            color: #000;
            font-size: 24px;
            font-weight: bold;
        }

        > select {
            width: auto;
            height: 34px;
        }

        > input {
            width: 180px;
            height: 34px;
        }
    }
}
</style>
